import React, { createContext, useContext } from 'react';
import { ProductClient } from '@jbhi-fi/apis/src/algolia/ProductClient';

export type ProductClientContextProps = {
  client: ProductClient;
};

type ProductClientProviderProps = ProductClientContextProps & {
  children: React.ReactNode;
};

export const ProductClientContext = createContext<ProductClient | null>(null);

export const ProductClientProvider = ({ client, children }: ProductClientProviderProps) => (
  <ProductClientContext.Provider value={client}>{children}</ProductClientContext.Provider>
);

export const useProductClientContext = (): ProductClient => {
  const context = useContext(ProductClientContext);
  if (!context) {
    throw new Error('useProductClient must be used within a ProductClientProvider');
  }
  return context;
};
